// Utbetaling (driverPayout) per ukedag for inneværende uke, mandag til søndag.

const DAY_LABELS = ['Ma', 'Ti', 'On', 'To', 'Fr', 'Lø', 'Sø'];

function startOfWeek(now) {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return d;
}

export function weekPayouts(invoices, now = new Date()) {
  const start = startOfWeek(now);
  const end = new Date(start);
  end.setDate(end.getDate() + 7);
  const days = DAY_LABELS.map(label => ({ label, amount: 0 }));

  for (const inv of invoices) {
    const date = inv.createdAt?.toDate?.() ?? (inv.createdAt ? new Date(inv.createdAt) : null);
    if (!date || Number.isNaN(date.getTime()) || date < start || date >= end) continue;
    days[(date.getDay() + 6) % 7].amount += inv.driverPayout ?? 0;
  }

  const total = days.reduce((sum, d) => sum + d.amount, 0);
  const max = Math.max(1, ...days.map(d => d.amount));
  return { days, total, max };
}
